export const name = 'fr_fr';
export const dictionary = {
    // GENERAL
    GEN_BACK: 'Retour',
    GEN_CLOSE: 'Fermer',
    GEN_LABEL_USER_ROLE_REGULAR: 'Standard',
    GEN_LABEL_USER_ROLE_ADMIN: 'Admininistrateur',
    GEN_LABEL_USER_ROLE_BUSINES_OWNER: "Chef d'entreprise",
    GEN_LABEL_EMAIL_ADDRESS: 'Adresse email',
    GEN_LABEL_FULL_NAME: 'Nom complet',
    GEN_LABEL_STATUS: 'Statut',
    GEN_LABEL_ACCESS_TYPE: "Type d'accès",
    GEN_LABEL_SENT_AT: 'Envoyé à',
    GEN_LABEL_PENDING: 'En attente',
    GEN_LABEL_VIEW: 'Voir',
    GEN_LABEL_EMPTY: 'Vide',
    GEN_LABEL_COMING_SOON: 'Prochainement',
    GEN_LABEL_SUBMIT: 'Envoyer',
    GEN_LABEL_FIRST_NAME: 'Prénom',
    GEN_LABEL_LAST_NAME: 'Nom',
    GEN_LABEL_PHONE: 'Numéro de téléphone',
    FORM_REQUIRED_FIELDS: 'Champ obligatoire',
    GEN_DOWNLOAD: 'Télécharger',
    // FOLDER
    FOLDER_ACCOUNTING: 'Comptabilité',
    FOLDER_AR: 'Comptes Débiteurs',
    FOLDER_PAYROLL: 'Paie',
    FOLDER_TAX: 'Documents pour Tax Return',
    FOLDER_QUICKBOOKS_FILE: 'Fichier Quickbooks',
    // BUCKET
    BUCKET_TAX_DOCUMENT: 'Documents pour Tax Return',
    BUCKET_LEGAL_DOCUMENT: 'Documents légaux',
    BUCKET_ACCOUNTING_DOCUMENT: 'Document Comptable',
    // LABEL
    LABEL_DRAG_N_DROP_FILES: 'Glisser/Déposer des fichiers ou cliquer ici',
    // ALERT
    ALERT_CONTACT_EMPLOYEE:
        "Pour des raisons de sécurité, vous ne pouvez pas inviter un Chef d'entreprise. Veuillez nous contacter pour ajouter un Chef d'entreprise.",
    ALERT_CANNOT_RESEND_INVITE: "L'invitation n'a pas pu être renvoyée",
    ALERT_CANNOT_CANCEL_INVITE: "L'invitation n'a pas pu être retirée",
    // MENU
    MENU_HOME: 'Accueil',
    MENU_FFDA_DASHBOARD: 'Tableau de bord',
    MENU_FFDA_REPORT: 'Rapports',
    MENU_DOCUMENTS: 'Drive',
    MENU_DOCUMENTS_UPLOAD: 'Centre de téléversement',
    MENU_ENTITY_FOLDER: 'Documents',
    MENU_SETTINGS: 'Paramètres',
    MENU_BILLING: 'Factures',
    // Top Bar
    TOP_BAR_MY_ACCOUNT: 'Mon compte',
    TOP_BAR_MY_SWITCH_ACCOUNT: "Changer d'entreprise",
    TOP_BAR_MY_LOG_OUT: 'Se Déconnecter',
    // Switch Account Modal
    SWCH_ACC_MDL_LABEL_TITLE: 'Choisir un contrat',
    SWCH_ACC_MDL_OTHER_CONTRACT: 'Accéder à vos autres contrats',
    // Homepage
    HOMEPAGE_TITLE_HOME: 'Accueil',
    HOMEPAGE_LABEL_WELCOME: 'Bienvenue!',
    HOMEPAGE_LABEL_ACCOUNT_SETUP: 'Configuration du compte',
    HOMEPAGE_LABEL_DOCUMENTS: 'Documents',
    HOMEPAGE_LABEL_DOCUMENTS_RECENT_TEXT: 'Activités récentes',
    HOMEPAGE_LABEL_TASK_ADD_USER: 'Inviter des utilisateurs',
    HOMEPAGE_LABEL_TASK_SECURE_MFA: 'Sécuriser mon compte avec 2FA',
    // Homepage - FFDA
    HOMEPAGE_TITLE_PROMO_HEADLINE: 'Federated Signature',
    HOMEPAGE_TITLE_PROMO_STATS_BOOKS: 'Stats Book',
    HOMEPAGE_TITLE_PROMO_SALARY_SURVEY: 'Salary Survey',
    // DASHBOARD
    DASHBOARD_TITLE: 'Tableau de bord',
    // SUPPLIES
    SUPPLIES_TITLE: 'Fournitures',
    // REPORTS
    REPORTS_SALES_ACTIVITY_TITLE: 'Rapport de Vente',
    REPORTS_EXPORTS_TITLE: 'Générer des rapports',
    REPORTS_SALES_ACTIVITY_DESC: 'Consulter vos rapports de vente',
    REPORTS_EXPORTS_DESC: 'Générer et exporter des rapports',
    // DRIVE
    DRIVE_FEXPLORER_TITLE_HOMEPAGE: 'Documents',
    DRIVE_FEXPLORER_TITLE_UPLOAD_CENTER: 'Centre de téléversement',
    DRIVE_FEXPLORER_TITLE_SEARCH_FILE: 'Recherche de fichiers',
    DRIVE_FEXPLORER_TITLE_FILE_EXPLORER: 'Explorateur de fichier',
    DRIVE_FEXPLORER_TITLE_DETAILS: 'Détails',
    DRIVE_FEXPLORER_TITLE_PREVIEW: 'Aperçu',
    DRIVE_FEXPLORER_FILE_NAME: 'Nom',
    DRIVE_FEXPLORER_FILE_SIZE: 'Taille du fichier',
    DRIVE_FEXPLORER_FILE_STATUS: 'Statut',
    DRIVE_FEXPLORER_FILE_UPLOADED_AT: 'Date de téléversement',
    DRIVE_FEXPLORER_FILE_LAST_UPDATE: 'Dernière activité',
    DRIVE_FEXPLORER_EXTENSION: 'Extension',
    DRIVE_FEXPLORER_LAST_ACTIVITY: 'Dernière activité',
    DRIVE_FEXPLORER_NOTHING_TO_SHOW: 'Rien à afficher.',
    DRIVE_FEXPLORER_CANNOT_PREVIEW:
        'Impossible de prévisualiser ce type de document',
    DRIVE_UPLOAD_SLCT_INBX: 'Choisir un dossier de récéption',
    DRIVE_UPLOAD_SLCT_CATEGORY: 'Select a year',
    DRIVE_UPLOAD_SLCT_BUCKET: 'Choisir un type de document',
    DRIVE_DETAILS_LABEL: 'Détails',
    DRIVE_DETAILS_COMMENTS: 'Commentaires',
    DRIVE_DETAILS_INFORMATION: 'Information',
    DRIVE_DETAILS_LABEL_MESSAGE: 'Message',
    DRIVE_DETAILS_LABEL_EMPTY_DISCUSSION: 'Pas de commentaire',
    // SETTINGS
    SETTINGS_PAGE_SETTINGS: 'Paramètres',
    SETTINGS_PAGE_SETTINGS_PREFERENCE: 'Paramètres - Préférences',
    SETTINGS_PAGE_SETTINGS_SECURITY: 'Paramètres - Sécurité',
    SETTINGS_PAGE_SETTINGS_ACCESS_MANAGEMENT: 'Paramètres - Gestion des accès',
    SETTINGS_PAGE_SETTINGS_BILLING: 'Paramètres - Facturation',
    SETTINGS_LABEL_LANGUAGE: 'Langue',
    SETTINGS_LABEL_PREFERENCES: 'Préférences',
    SETTINGS_LABEL_PROFILE: 'Profil',
    SETTINGS_LABEL_PROFILE_DESC:
        'Mettre à jour vos informations et préférences.',
    SETTINGS_LABEL_SECURITY: 'Sécurité',
    SETTINGS_LABEL_SECURITY_DESC: 'Gérer la sécurité de votre compte.',
    SETTINGS_LABEL_ACCESS_MANAGEMENT: 'Gestion des accès',
    SETTINGS_LABEL_ACCESS_MANAGEMENT_DESC: 'Inviter et gérer les utilisateurs.',
    SETTINGS_LABEL_UPLOAD_LIST: 'Fichiers à Téléverser',
    SETTINGS_LABEL_UPLOAD_LIST_EMPTY: 'Pas de fichier à téléverser.',
    SETTINGS_LABEL_UPLOAD_WILL_BE_UPLOADED: 'Sera téléversé dans',
    SETTINGS_LABEL_AUTO_UPLOAD: 'Envoi automatique',
    SETTINGS_LABEL_FILE_UPLOADED: 'Fichier reçu',
    SETTINGS_LABEL_FILE_UPLOAD_FAILED: "Echec d'envoi du fichier",
    SETTINGS_LABEL_FILE_SIZE_LIMIT: 'Limite de taille de fichier',
    SETTINGS_LABEL_BILLING: 'Facturation',
    SETTINGS_LABEL_BILLING_DESC:
        "Gérer votre moyen de paiement et accéder à l'historique des factures.",
    // Error files upload
    UPLOAD_FILE_ERROR_LIMIT_EXCEEDED: 'Limite de taille de fichier dépassée',
    UPLOAD_FILE_ERROR_UNKNOWN:
        'Impossible de télécharger le fichier, veuillez réessayer plus tard. Si le problème persiste, contactez le support.',
    // Settings: Security
    SETTINGS_P_SEC_CARD_2FA_SETUP: 'Validation en deux étapes',
    // Settings: Access Management
    SETTINGS_LABEL_INVITE_USER: 'Inviter',
    SETTINGS_LABEL_CONFIRM_USER_INVITE_REMOVAL:
        "Confirmer le retrait de l'invitation",
    SETTINGS_LABEL_CONFIRM_USER_INVITE_RESEND:
        "Confirmer le renvoi d'invitation",
    SETTINGS_LABEL_BTN_RESEND_INVITE: 'Renvoyer',
    SETTINGS_LABEL_BTN_CANCEL_INVITE: "Annuler l'invitation",
    SETTINGS_LABEL_TAB_ALL: 'Tous',
    SETTINGS_LABEL_TAB_ACTIVE: 'Actif',
    SETTINGS_LABEL_TAB_INACTIVE: 'Inactif',
    SETTINGS_LABEL_TAB_PENDING_IVTS: 'En attente',
    SETTINGS_LABEL_NO_PDN_IVT: "Pas d'invitation en attente",
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_EXISTS:
        "Une demande de mise à jour d'email avec l'adresse suivante est en attente de validation par un employé",
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_UPDATED:
        'Adresse e-mail mise à jour avec succès.',
    SETTINGS_ACCESS_INFO_UPDATE_EMAIL_SENT:
        "Demande de changement d'adresse email envoyée avec succès, un email vous a été envoyé pour confirmer votre demande.",
    // Settings: Access Management - Invite Modal
    SETTINGS_INV_MDL_TITLE: "Inviter quelqu'un",
    SETTINGS_INV_MDL_BTN_SEND: "Envoyer l'invitation",
    SETTINGS_INV_MDL_BTN_SENDING: "Envoi de l'invitation...",
    SETTINGS_INV_MDL_INV_SENT: 'Invitation envoyée!',
    SETTINGS_INV_MDL_INV_OOPS:
        'Nous avons rencontré un problème, merci de réessayer.',
    SETTINGS_INV_MDL_INV_EXISTS:
        'Une invitation pour cet utilisateur a déjà été envoyée.',
    // Settings: Billing - Homepage
    BILLING_PAY_NOW: 'Payer maintenant',
    SETTINGS_BILLG_LABEL_LAST_PAYMENT: 'Dernier payment reçu',
    SETTINGS_BILLG_LABEL_CURRENT_BILL: 'Facture en cours',
    SETTINGS_BILLG_LABEL_RETAINER: 'Avoir à valoir',
    SETTINGS_BILLG_LABEL_BALANCE: 'Balance',
    SETTINGS_BILLG_LABEL_PAY_BALANCE_TITLE: 'Reste à payer estimé',
    SETTINGS_BILLG_LABEL_PAY_BALANCE_TOOLTIP:
        'Ceci est une estimation en direct du solde dû avant validation.',
    // Cookie - Authorization
    PROMPT_AUTHRZ_COOKIE_TITLE: 'Nous avons des cookies',
    PROMPT_AUTHRZ_COOKIE_TEXT:
        "Nous utilisons des cookies et d'autres technologies de suivi pour améliorer votre expérience de navigation sur notre site web, pour analyser le trafic de notre site web et pour comprendre d'où viennent nos visiteurs.",
    PROMPT_AUTHRZ_COOKIE_BTN_AGREE: 'Accepter',
    PROMPT_AUTHRZ_COOKIE_BTN_DECLINE: 'Refuser',
    // Authentication - Login
    LOGIN_FAILED_WAITING_PERMISSION:
        "Connexion refusée, vos permissions doivent être données par un chef d'entreprise",
};

export default {
    name,
    dictionary,
};
